export const BASE_PATH = '/auth/v1';
